import { type UIEvent, useState } from 'react';
import type { OccurrenceWithTimeSpent } from '../../../models/occurrence';
import useMtText from './useMtText';

interface IBoardColumnCardsProps {
    items: OccurrenceWithTimeSpent[];
    estimateMs?: number;
    plateByChassis: Map<string, string>;
    onOpen: (occurrenceId: string) => void;
}

const PAGE = 30;
const LOAD_OFFSET = 120;

const BoardColumnCards = ({ items, estimateMs, plateByChassis, onOpen }: IBoardColumnCardsProps) => {
    const { t, formatNumber, formatDuration } = useMtText();
    const [visible, setVisible] = useState(PAGE);
    const hidden = items.length - visible;

    const handleScroll = (event: UIEvent<HTMLDivElement>) => {
        const list = event.currentTarget;
        if (hidden > 0 && list.scrollTop + list.clientHeight >= list.scrollHeight - LOAD_OFFSET) {
            setVisible(value => value + PAGE);
        }
    };

    return (
        <div className='mt-board__list' onScroll={handleScroll}>
            {items.slice(0, visible).map(item => {
                const elapsedMs = item.currentStepTotalTime * 60 * 1000;
                const late = estimateMs !== undefined && elapsedMs > estimateMs;
                return (
                    <button
                        type='button'
                        key={item.occurrenceId}
                        className='mt-board__card'
                        onClick={() => onOpen(item.occurrenceId)}
                    >
                        <span className='mt-board__row'>
                            <b>{plateByChassis.get(item.chassis) || item.chassis}</b>
                            {late && <span className='mt-alert'>{t('table.alert')}</span>}
                        </span>
                        <span className='mt-board__row'>
                            <small>{item.customer}</small>
                            <small className='mt-num'>{formatDuration(elapsedMs)}</small>
                        </span>
                    </button>
                );
            })}
            {hidden > 0 && (
                <button type='button' className='mt-board__more' onClick={() => setVisible(value => value + PAGE)}>
                    {t('board.more', { count: formatNumber(hidden) })}
                </button>
            )}
        </div>
    );
};

export default BoardColumnCards;
